import { Loader, Row } from 'components/Blocks';

export function SyncAdvise() {
  return (
    <div className="fixed bottom-0 right-1 h-1 w-1">
      <Row className="absolute bottom-2 right-2 w-auto select-none rounded-md border bg-muted p-1 animate-in slide-in-from-bottom-4">
        <span className="text-sm text-primary">Syncing...</span>

        <Loader type="dualRing" size={14} />
      </Row>
    </div>
  );
}
